import { Box, Button, Modal, Typography } from "@mui/material";
import { collection, doc, getDocs, query, setDoc, updateDoc, where } from "firebase/firestore";
import React, { useEffect, useState } from "react";
import { db } from "../firebase_config";

const FormApproveCompanyRequests = ({ setApproveRequestsModal }) => {
  const [requests, setRequests] = useState([]);

  const fetchRequests = async () => {
    const q = query(collection(db, "CompanyRequests"), where("status", "==", "pending"));
    const snapshot = await getDocs(q);
    const reqs = snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
    setRequests(reqs);
  };

  const approve = async (request) => {
    await setDoc(doc(db, "Company", request.uid), {
      uid: request.uid,
      email: request.email,
      company: request.requestedCompany,
    });

    await updateDoc(doc(db, "CompanyRequests", request.id), {
      status: "approved",
      approvedAt: new Date(),
    });

    alert(`Godkände ${request.email}`);
    fetchRequests(); // Refresh list
  };

  useEffect(() => {
    fetchRequests();
  }, []);

  return (
    <Modal open onClose={() => setApproveRequestsModal(false)}>
      <Box sx={{ 
        position: "absolute", top: "50%", left: "50%", transform: "translate(-50%, -50%)",
        bgcolor: "background.paper", boxShadow: 24, p: 4, borderRadius: 2, width: 400
      }}>
        <Typography variant="h6" mb={2}>Godkänn Företagsförfrågningar</Typography>
        {requests.length === 0 && <Typography>Inga förfrågningar</Typography>}
        {requests.map((req) => (
          <Box key={req.id} sx={{ mb: 2 }}>
            <Typography variant="body2">
              <strong>{req.email}</strong> vill kopplas till <strong>{req.requestedCompany}</strong>
            </Typography>
            <Button variant="contained" size="small" onClick={() => approve(req)}>Godkänn</Button>
          </Box>
        ))}
        <Box mt={2}>
          <Button onClick={() => setApproveRequestsModal(false)} variant="outlined" color="error">
            Stäng
          </Button>
        </Box>
      </Box>
    </Modal>
  );
};

export default FormApproveCompanyRequests;